import { isString } from "../utils/langUtils";

type WarningBoxProps = {
  readonly id?: string;
  readonly title?: string;
  readonly message?: string | React.ReactElement;
  readonly type?: "info" | "warning" | "error";
};

export function WarningBox({ id, title, message, type }: WarningBoxProps) {
  return (
    <div id={id} className={`warning-box warning-box-${type}`}>
      <div>
        <h3>
          <span
            className={`warning-box-icon icon2-eh-notification ninja-icon warning-box-icon-${type}`}
          />
        </h3>
      </div>
      <div className="warning-box-content">
        <h3>{title}</h3>
        {isString(message) ? (
          <p id="warning-box-content-string">{message}</p>
        ) : (
          <div id="warning-box-content-element">{message}</div>
        )}
      </div>
    </div>
  );
}

export default WarningBox;
